import {SmartComponent} from "smart-component-js";
import GigyaManager from "../business/GigyaManager";
import Utility from "../business/Utility";
import CollectionPromoApi from "mbpromo/src/collection-api/CollectionPromoApi";
import Constants from "../business/Constants";

class SurveyCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.chat = new Promise((resolve) => {
			// eslint-disable-next-line no-undef
			if (typeof window.$ec === undefined) {
				if (!window.checkIntervalChat) {
					window.checkIntervalChat = setInterval(function () {
						// eslint-disable-next-line no-undef
						if (window.$ec) {
							clearInterval(window.checkIntervalChat);
							resolve();
						}
					}, 500);
				}
			} else {
				return resolve();
			}
		});
		this.init();
		Utility.enableHolidaysMessage();
	}

	isChatReady() {
		return this.chat;
	}

	getAreaPersonale() {
		Utility.startLoader();
		GigyaManager.getLoggedUserCached().then((u) => {
			this.userID = u.UID;

			this.collectionPromoApi.areaPersonale(this.userToken).then(
				(resp) => {
					let body = resp.body;
					this.isChatReady().then(() => {
						if (!body.registrato) {
							// eslint-disable-next-line no-constant-condition,no-undef
							window.$ec.addUserInfo({
								promozione: Constants.TRACKING_PROMOCODE,
								pagecode: document.location.href,
								browserName: Utility.getDeviceInfo().browserName,
								browserVersione: Utility.getDeviceInfo().browserVersion,
								osName: Utility.getDeviceInfo().osName,
								osVersione: Utility.getDeviceInfo().osVersion,
								device: Utility.getDeviceInfo().device
							});
						} else {
							// eslint-disable-next-line no-constant-condition,no-undef
							window.$ec.addUserInfo({
								idGigya: resp.body.gigya_uid,
								promozione: Constants.TRACKING_PROMOCODE,
								pagecode: document.location.href,
								browserName: Utility.getDeviceInfo().browserName,
								browserVersione: Utility.getDeviceInfo().browserVersion,
								osName: Utility.getDeviceInfo().osName,
								osVersione: Utility.getDeviceInfo().osVersion,
								device: Utility.getDeviceInfo().device,
								email: resp.body.email,
								telefono: resp.body.telefono,
								nome: resp.body.nome,
								cognome: resp.body.cognome
							});
						}
					});

					body.registrato ? this.checkSurveyCompletion() : this.goToReservedArea();
				},
				() => Utility.removeLoader())
		}, () => this.goToReservedArea())
	}

	checkSurveyCompletion() {
		this.collectionPromoApi.checkSurveyDone().then(
			(resp) => {
				resp.body.completata_survey ? this.showThankYou() : this.showSurvey();
				Utility.removeLoader();
			}
		)
	}

	showSurvey() {
		this.formElement.classList.add('visible');
		this.addListeners();
		this.setSecondQuestionLabel();
	}

	goToReservedArea() {
		window.location.href = '/promozioni/raccolta-punti-colazione/area-personale';
	}

	addListeners() {
		this.startButton.addEventListener('click', () => this.showStep1())
		this.nextButton.addEventListener('click', () => this.goToNextStep());
		this.form.addEventListener('change', (e) => {
			this.checkValidation(e);
			this.nextStep = e.target.getAttribute("data-goto");
		});
	}


	setSecondQuestionLabel() {
		let firstQuestionRadioButtons = this.formElement.querySelectorAll('#step1 input[type=radio]');
		let secondQuestionLabels = this.formElement.querySelectorAll('#step2a .mb-survey__question');
		firstQuestionRadioButtons.forEach(radio => radio.addEventListener('change', () => {
			secondQuestionLabels.forEach(el => el.classList.add('hidden'));
			const dataLabelAttribute = radio.getAttribute('data-label');
			this.formElement.querySelector('#step2a .mb-survey__question.' + dataLabelAttribute)?.classList.remove('hidden');
		}));
	}

	checkValidation(e) {
		if(e.target.value === 'OTHER') this.formElement.querySelector('#'+ this.currentStep +' input[type=text]').disabled = !e.target.checked;
		const otherCheckboxElement = this.formElement.querySelector('#'+ this.currentStep +' .mb-survey__answer--other');
		if(otherCheckboxElement) this.showValidationOtherInput(otherCheckboxElement);
		const isValid = this.validateActiveStep();
		this.nextButton.disabled = !isValid;
		if(this.nextStep === 'thankyoupage') this.saveButton.disabled = !isValid;
	}

	checkOtherValue(target) {
		if(target.value !== 'OTHER') return true;
		const checked = target.checked;
		const otherInput = this.formElement.querySelector('#'+ this.currentStep +' input[type=text]');
		return !(checked && otherInput.value === '');
	}

	showValidationOtherInput(otherWrapper) {
		const inputText = otherWrapper.querySelector('input[type="text"]');
		const checkboxElement = otherWrapper.querySelector('input[type="checkbox"]');
		const validationMessage = otherWrapper.querySelector('.validation-required');
		(checkboxElement.checked && inputText.value === '') ?
			validationMessage.classList.add('visible') :
			validationMessage.classList.remove('visible');
	}

	showStep1() {
		this.formElement.classList.remove('visible');
		setTimeout(() => {
			document.getElementById('step0').classList.add('hidden');
			document.getElementById('step1').classList.remove('hidden');
			this.nextButton.classList.remove('hidden');
			this.formElement.classList.add('visible');
		}, 500);
	}

	goToNextStep() {
		this.nextButton.disabled = true;
		this.formElement.classList.remove('visible');
		if(this.nextStep === 'step6') this.showSaveButton();
		setTimeout(() => {
			document.getElementById(this.currentStep).classList.add('hidden');
			document.getElementById(this.nextStep).classList.remove('hidden');
			this.currentStep = this.nextStep;
			this.nextStep = undefined;
			this.formElement.classList.add('visible');
		}, 500);
	}

	showSaveButton() {
		this.nextButton.classList.add('hidden');
		this.saveButton.classList.remove('hidden');
		this.saveButton.addEventListener('click', () => this.saveData());
	}

	saveData() {
		Utility.startLoader();
		let data = this.getDataJson();
		this.collectionPromoApi.completeSurvey(data).then(
			(response) => {
				console.log(response);
				this.showThankYou();
				Utility.removeLoader();
			},
			(error) => console.error(error)
		)
	}


	getDataJson() {
		let form = new FormData(this.form);
		return {
			userId: this.userID,
			timestamp: new Date().getTime(),
			step1: { value: form.get('step1') },
			step2a: { value: form.getAll('step2a') },
			step2b: {
				value: form.getAll('step2b'),
				otherValue: form.get('other2')
			},
			step3: {
				valueCoccio: form.get('step3coccio'),
				valueBiscotazza: form.get('step3biscotazza'),
				valueMattutina: form.get('step3mattutina')
			},
			step4: {
				valueCoccio: form.get('step4coccio'),
				valueBiscotazza: form.get('step4biscotazza'),
				valueMattutina: form.get('step4mattutina')
			},
			step5: { value: form.get('step5') },
			step6: {
				value: form.getAll('step6'),
				otherValue: form.get('other6')
			}
		};
	}

	showThankYou() {
		document.querySelector('.mb-survey__body').innerHTML = `
    	<div class="mb-survey__ty-page">
    	   	<img src="https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/section/ape.png" alt="ape">
			<h2>Grazie del tuo contributo!</h2>
			<div class="mb-survey__text">Subito per Te i <strong>Punti OMAGGIO SPECIALI</strong> da utilizzare per completare più facilmente la tua tessera richiesta premio:</div>
			<img src="https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/premi/survey-premi-punti.svg" alt="premi">
			<div class="mb-survey__text">
				Se hai già iniziato la raccolta, scarica il <strong>Carnet</strong> dei Punti OMAGGIO SPECIALI, ritagliali e incollali sulla tua tessera.
				Se non hai ancora la <strong>tessera</strong>, scaricala già completa dei Punti OMAGGIO. 
			</div>
			
			<div class="mb-survey__button-container">
				<a target="_blank" href="${ window.API_ENDPOINT }/api/mulinobianco/1.0/web/promo-engine/collection/colazione-2022/download/bonus/carnet?u=${ this.userID }" download>
					Scarica il Carnet
				</a>
				<a target="_blank" href="${ window.API_ENDPOINT }/api/mulinobianco/1.0/web/promo-engine/collection/colazione-2022/download/bonus/tessera?u=${ this.userID }" download>
					Scarica le tessere
				</a>
			</div>
			
			<div class="mb-survey__note">* ATTENZIONE: i Punti OMAGGIO SPECIALI non sono cumulabili. Ricordati che i 2 punti OMAGGIO SPECIALI COCCIO puoi utilizzarli solo per richiedere il premio della 1° soglia, i 3 punti OMAGGIO SPECIALI BISCOTAZZA puoi applicarli solo per richiedere il premio della 2° soglia e i 5 punti OMAGGIO SPECIALI MATTUTINA sono dedicati solo per le richieste premio della 3° soglia.</div>
		</div>
		`;
	}

	validateActiveStep() {
		/* eslint-disable no-case-declarations */
		const objValidation = Utility.getSurveyValidation()[this.currentStep];
		const inputNames = objValidation.names || [this.currentStep];
		switch(objValidation.type) {
		case 'radio':
			return !inputNames.some((name) => !this.form.elements[name].value);
		case 'checkbox':
			return !inputNames.some((name) => {
				let checkedCheckbox = document.querySelectorAll('#'+ this.currentStep +' input[name='+ name +']:checked');
				let isOtherValueValid = true;
				checkedCheckbox.forEach((el) => isOtherValueValid = this.checkOtherValue(el));
				const minLength = objValidation.minLength ? checkedCheckbox.length >= objValidation.minLength : true;
				const maxLength = objValidation.maxLength ? checkedCheckbox.length <= objValidation.maxLength : true;
				this.showValidationMessage(minLength, maxLength, objValidation);
				return !minLength || !maxLength || !isOtherValueValid;
			})
		}
	}

	showValidationMessage(min, max, validation) {
		let message = '';
		if(!min) message = 'Seleziona almeno ' + validation.minLength + this.getAnswerLabel(validation.minLength);
		if(!max) message = 'Puoi selezionare al massimo ' + validation.maxLength + this.getAnswerLabel(validation.maxLength);
		this.validationContainer.innerHTML = message;
	}

	getAnswerLabel(length) {
		return (length === 1) ? ' risposta': ' risposte';
	}

	initializeVar() {
		this.formElement = document.querySelector('form.mb-survey__form');
		this.nextButton = document.querySelector('.mb-survey__next');
		this.saveButton = document.querySelector('.mb-survey__save');
		this.startButton = document.querySelector('.mb-survey__start');

		this.collectionPromoApi = new CollectionPromoApi({promoCode: Constants.API_PROMOCODE});
		this.validationContainer = this.formElement.querySelector('.validation-error'),
		this.form = document.forms.mbSurvey;
		this.currentStep = 'step1';
	}

	hideMenuIcon() {
		document.querySelector('.header .menu-icon').style.display = 'none';
		document.querySelector('.header .profile-icon').style.display = 'none';
		document.querySelector('.header .search-icon').style.display = 'none';
	}

	init() {
		this.loadChildComponents(this);
		this.initializeVar();
		this.hideMenuIcon();
		this.getAreaPersonale();
	}
}

export default SurveyCtrl;

